import React from "react";
import { Star, Shield, Award, MapPin, BadgeCheck } from "lucide-react";
import { useGoogleReviews } from "../../lib/useGoogleReviews";
import { REVIEW_RATING, REVIEW_COUNT } from "../../lib/site";

const TrustBar = () => {
  const g = useGoogleReviews();
  const rating = (g.configured && g.rating ? g.rating : REVIEW_RATING).toFixed(1);
  const count = g.configured && g.total ? g.total : REVIEW_COUNT;
  const reviewSub = `${count} Reviews`;

  const ITEMS = [
    { icon: Star, label: `${rating} Stars on Google`, sub: reviewSub },
    { icon: Shield, label: "Licensed • Bonded • Insured", sub: "Fully Covered" },
    { icon: Award, label: "Residential Lifetime Warranty", sub: "For Original Homeowner" },
    { icon: MapPin, label: "Local Northern Arizona", sub: "Not a Franchise" },
    { icon: BadgeCheck, label: "Free Estimates", sub: "No Obligation", hideOnMobile: true },
  ];

  return (
    <section className="bg-zinc-950 border-y border-zinc-900" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-5 lg:px-12 py-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
        {ITEMS.map((it, i) => (
          <div key={i} className={`flex items-center gap-3${it.hideOnMobile ? " hidden md:flex" : ""}`}>
            <div className="w-11 h-11 shrink-0 bg-[#C69453]/10 border border-[#C69453]/30 flex items-center justify-center text-[#C69453]">
              <it.icon className="w-5 h-5" />
            </div>
            <div className="leading-tight">
              <p className="text-white font-semibold text-sm">{it.label}</p>
              <p className="text-zinc-500 text-xs">{it.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBar;
